import React from "react";
import { Box, Grid, Chip } from "@mui/material";
import {
  InfoOutlined,
  DateRangeOutlined,
  SettingsOutlined,
  BusinessOutlined,
  Person,
} from "@mui/icons-material";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import { localizeDateTimeShort } from "utils/dateFormats";
import { useSmsIntegrationDetailContext } from "contexts/SmsIntegrationDetailContext";
import Status from "components/Shared/Status";




const SmsIntegrationBasicDetail = () => {
  const { smsIntegrationDetail, loadingSmsIntegration } =
    useSmsIntegrationDetailContext();

  return !loadingSmsIntegration ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <SettingsOutlined color="primary" />}
            title="Provider"
            subtitle={smsIntegrationDetail?.provider?.name || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <BusinessOutlined color="primary" />}
            title="Vendor"
            subtitle={smsIntegrationDetail?.vendor?.shopName || "N/A"}
          />
        </Grid>
<Grid item xs={3}>
  <InformationTile
    icon={() => <SettingsOutlined color="primary" />}
    title="Default"
    subtitle={
      smsIntegrationDetail?.isDefault === true
        ? "True"
        : smsIntegrationDetail?.isDefault === false
        ? "False"
        : "N/A"
    }
  />
</Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Status"
          >
            <Status isActive={smsIntegrationDetail?.isActive} />
          </InformationTile>
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <DateRangeOutlined color="primary" />}
            title="Created At"
            subtitle={
              smsIntegrationDetail?.createdAt
                ? localizeDateTimeShort(smsIntegrationDetail.createdAt)
                : "N/A"
            }
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <Person color="primary" />}
            title="Created By"
            subtitle={smsIntegrationDetail?.createdBy?.name || "N/A"}
          />
        </Grid>
        <Grid item xs={12}>
          <InformationTile
            icon={() => <SettingsOutlined color="primary" />}
            title="Parameters"
            subtitle={
              smsIntegrationDetail?.parameters
                ? JSON.stringify(smsIntegrationDetail.parameters, null, 2)
                : "N/A"
            }
          />
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default SmsIntegrationBasicDetail;
